import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { KNOWN_STORAGE_BUCKETS } from './drawingSanitize';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

/**
 * SAY WHICH PROJECT THIS IS. Silence here cost an afternoon.
 *
 * A `.env.local` dated March pointed local dev at `levelupclassroom-staging`,
 * and in Vite `.env.local` outranks `.env` — so `npm run dev` had been talking
 * to staging for months while everyone assumed production. Staging's rules were
 * five months stale, so writes were denied with a bare "Missing or insufficient
 * permissions" and nothing anywhere named the project. The bug looked like a
 * rules regression in production, which it was not.
 *
 * One line, printed always: whatever else is confusing, the target is not.
 */
const PROD_PROJECT_ID = 'aero-app-4bb06';
if (firebaseConfig.projectId !== PROD_PROJECT_ID) {
  console.warn(
    `[firebase] NOT PRODUCTION — connected to "${firebaseConfig.projectId}". ` +
    `Data written here does not appear on levelupclassroom.com. ` +
    `(Set by .env.local, which overrides .env.)`,
  );
} else {
  console.log(`[firebase] project: ${firebaseConfig.projectId}`);
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;

/**
 * Storage buckets a CLIENT-side sanitize check should accept: this deployment's
 * configured bucket first, plus the project's other known aliases so a config
 * difference can never silently drop a student's real uploaded work.
 * See drawingSanitize.ts — the server binds its own list the same way.
 */
export const clientStorageBuckets = (): readonly string[] => {
  const configured = (import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '').trim();
  return configured && !KNOWN_STORAGE_BUCKETS.includes(configured)
    ? [configured, ...KNOWN_STORAGE_BUCKETS]
    : KNOWN_STORAGE_BUCKETS;
};
